<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <h2 class="island">
          {{ lang.get('judging.fast_start.rounds.title') }}
        </h2>
      </div>
      <div class="col-xs-12 col-lg-6">
        <div class="panel panel-default">
          <div class="panel-body">
            <gallery-dates v-if="scoreSet.mode === 'gallery'" />
            <div v-else>
              <rounds-table></rounds-table>
              <button
                class="btn btn-secondary"
                :disabled="configuredRound !== null"
                @click="newRound = !newRound"
              >
                {{ lang.get('judging.fast_start.rounds.new') }}
              </button>
            </div>
          </div>
        </div>
        <round
          v-if="newRound || configuredRound"
          :round-id="configuredRound"
          :round-template="roundTemplate"
          :routes="routes"
          @saved="onSaved"
        />
      </div>
    </div>
    <navigation :final-step="true" v-on="$listeners" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import Navigation from '../Navigation';
import Round from './Round';
import RoundsTable from './RoundsTable';
import GalleryDates from './GalleryDates';

export default {
  inject: ['lang'],
  components: {
    Navigation,
    Round,
    RoundsTable,
    GalleryDates
  },
  props: {
    roundTemplate: {
      type: Object,
      default: () => ({})
    },
    routes: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      newRound: false
    };
  },
  computed: {
    ...mapGetters('judgingFastStart', ['scoreSet']),
    ...mapState('judgingFastStart', ['configuredRound'])
  },
  methods: {
    ...mapMutations('judgingFastStart', ['configureRound']),
    onSaved() {
      this.newRound = false;
      this.configureRound(null);
    }
  }
};
</script>
